<template>
    <a-form
            :model="formInline"
            name="basic"
            autocomplete="off"
            @finish="handleSubmit"
    >
      <div v-if="isDEV">
        <a-form-item
                name="account"
                :rules="[{ required: true, message: '请输入手机号或用户名' }]"
        >
          <a-input v-model:value="formInline.account" placeholder="请输入用户名"/>
        </a-form-item>

        <a-form-item
                name="password"
                :rules="[{ required: true, message: '请输入密码' }]"
        >
          <a-input-password v-model:value="formInline.password" placeholder="请输入密码"/>
        </a-form-item>
        <a-form-item
                name="tel"
                :rules="[{ required: true, message: '请输入常用手机号' }]"
        >
          <a-input v-model:value="formInline.tel"  placeholder="请输入常用手机号"/>
        </a-form-item>
        <a-form-item
                name="code"
                :rules="[{ required: !isDEV, message: '请输入手机验证码' }]"
        >
          <a-input v-model:value="formInline.code" style="width: 50%" placeholder="请输入手机验证码"/>&nbsp;
          <a-button style="float: right; width: 48%" block @click="getCode" :disabled="disabled">{{btnText}}</a-button>
        </a-form-item>
        <div style="text-align: center; margin-bottom: 15px">
          <a-button type="primary"  html-type="submit">提交</a-button>
        </div>
      </div>
    </a-form>
</template>

<script>

  import {isDEV} from '@/utils/request';
  import {jy_tip} from '@/utils/vue.tool';

  import {delete_auth_tel, post_auth_code_unbind} from "../../utils/paper.account";


  export default {
    name: "UnbindTel",
    data() {
      let tel = isDEV? '15538819853': '';
      return {
        isDEV,
        openPwd: false,
        disabled: false,
        formInline: {
          account: tel,
          password: isDEV? 'hpp.123456': '',
          tel
        },
        business: '',
        unRegister: false,
        btnText: '获取验证码',
        formErrors: {
          telError: ''
        },
      };
    },
    methods: {

      handleSubmit() {
        delete_auth_tel(this.formInline, (res)=>{
          let {message, status} = res;
          if(status === 2) jy_tip('手机号已解除', 'success');
          else jy_tip('解除手机号： ' + message);
        })
      },
      getCode(){
        let s = 60;
        let {tel, account, password} = this.formInline;
        if(!tel){
          this.setError( 'tel', '请输入手机号');
          return;
        }else this.setError( 'tel', '');
        this.disabled = true;
        const timer = setInterval(function () {
          s -- ;
          this.btnText = (`${s}秒后重新获取`);
          if(s <= 0) {
            clearInterval(timer);
            this.disabled = false;
            this.btnText = ('重新获取验证码');
          }
        }, 1000);
        post_auth_code_unbind({tel, account, password}, (res)=>{
          let {status, message} = res;
          if(status !== 2) jy_tip('获取解除绑定的验证码：' + message)
        });

      },
      setError(key, msg){
        this.formErrors[key + 'Error'] = msg;
        // obj.$refs.formRef.validateField(msg);
      }
    },
  }
</script>

<style scoped>

</style>

